/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React from 'react'
import { Route, Routes } from 'react-router-dom';
import FocusModeCompletedV2 from '../Components/FocusTimer/FocusModeCompletedV2';
import FocusModeStart from '../Components/FocusTimer/FocusModeStart';
import TimerCompleted from '../Components/FocusTimer/TimerCompleted';
import BreakCompleted from '../Components/FocusTimer/BreakCompleted';
import DashboardLayout from '../Components/common/DashboardLayout';
import Logout from './Logout';
import PlanUpgrade from './PlanUpgrade';
import RitualsPage from "./HomePage/Rituals/RitualsPage";
import TodoistAuth from "../Components/Integration/TodoistAuth";
// import GoogleAuth from "../Components/Integration/GoogleAuth";

const PrivateRoutes = React.memo(({activeTimer, pause, start, fullscreen}) => {
    
    return (
        <div id="private-wrapper">
            <Routes>
                <Route path='/logout' element={<Logout />} />
                <Route path='/plan-upgrade' element={<PlanUpgrade />} />
                {
                    (activeTimer === 'focusMode') && fullscreen === true
                    ?
                    <>
                        <Route path='/focus-mode-completed' element={<FocusModeCompletedV2 />}/>
                        <Route path='/*' element={<FocusModeStart />}/>
                    </>
                    :
                    (
                        pause === true && start === true && fullscreen === true
                        ?
                        <Route path='/*' element={<FocusModeStart timerPaused={true} />}/>
                        :
                        <>
                            <Route path='/focus-completed' element={<TimerCompleted/>}/>
                            <Route path='/break-completed' element={<BreakCompleted/>}/>
                            <Route path='/auth/todoist' element={<TodoistAuth />}/>
                            {/* <Route path='/auth/callback' element={<GoogleAuth />}/> */}
                            <Route path='/morning-rituals' element={<RitualsPage />}/>
                            <Route path='/*' element={<DashboardLayout />} />
                        </>
                    )
                }
            </Routes>
        </div> 
    )
});

export default PrivateRoutes